import { LitElement, html, css } from 'lit-element';
import { Theme } from '@furo/framework/src/theme.js';
import { FBP } from '@furo/fbp';
import { i18n } from '@furo/framework';

/**
 * `part-pruefergebnis`
 * todo Describe your element
 *
 * @summary todo shortdescription
 * @customElement
 * @demo demo-part-pruefergebnis
 * @appliesMixin FBP
 */
class PartPruefergebnis extends FBP(LitElement) {
  bindData(d) {
    this._FBPTriggerWire('--fields', d);
  }

  /**
   * Themable Styles
   * @private
   * @return {CSSResult}
   */
  static get styles() {
    // language=CSS
    return (
      Theme.getThemeForComponent('PartPruefergebnis') ||
      css`
        :host {
          display: block;
        }

        :host([hidden]) {
          display: none;
        }

        h3 {
          margin-top: 56px;
          font-weight: Normal;
          font-size: 24px;
          letter-spacing: 0;
        }

        .io-nio > furo-data-checkbox-input {
          width: 80px;
        }

        furo-form-layouter > div {
          line-height: 67px;
        }

        furo-form-layouter > furo-horizontal-flex > div {
          line-height: 67px;
        }
      `
    );
  }

  /**
   * @private
   * @returns {TemplateResult}
   * @private
   */
  render() {
    // language=HTML
    return html`
      <h3>${i18n.t('objekt-protokoll_abs_pruefergebnis')}:</h3>

      <furo-form-layouter four>
        <div>${i18n.t('objekt-protokoll_titel_maengel_festgestellt')}</div>
        <furo-horizontal-flex class="io-nio">
          <furo-data-checkbox-input
            condensed
            ƒ-bind-data="--fields(*.maengel_io_l)"
            @-click="--maengel_io"
            ƒ-uncheck="--maengel_nio"
          ></furo-data-checkbox-input>
          <furo-data-checkbox-input
            condensed
            ƒ-bind-data="--fields(*.maengel_nio_l)"
            @-click="--maengel_nio"
            ƒ-uncheck="--maengel_io"
          ></furo-data-checkbox-input>
        </furo-horizontal-flex>
      </furo-form-layouter>

      <furo-form-layouter four>
        <furo-data-textarea-input
          full
          label="${i18n.t('objekt-protokoll_label_pruefergebnis_maengel')}"
          style="width: 100%;"
          ƒ-bind-data="--fields(*.maengel_text)"
        ></furo-data-textarea-input>
      </furo-form-layouter>

      <furo-form-layouter four>
        <furo-horizontal-flex full class="io-nio">
          <div flex>${i18n.t('objekt-protokoll_abs_elektroregel')}</div>
          <furo-data-checkbox-input
            condensed
            ƒ-bind-data="--fields(*.regel_io_l)"
            @-click="--regel_io"
            ƒ-uncheck="--regel_nio"
          ></furo-data-checkbox-input>
          <furo-data-checkbox-input
            condensed
            ƒ-bind-data="--fields(*.regel_nio_l)"
            @-click="--regel_nio"
            ƒ-uncheck="--regel_io"
          ></furo-data-checkbox-input>
        </furo-horizontal-flex>
      </furo-form-layouter>
    `;
  }
}

window.customElements.define('part-pruefergebnis', PartPruefergebnis);
